module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/items"
    }
  }, [_vm._v("Items")]), _vm._v(" "), _c('el-submenu', {
    staticClass: "profile",
    attrs: {
      "index": "user"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/profile"
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "signout"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign out")])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0758cb76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 219
// module chunks = 1